import { render, staticRenderFns } from "./goodsHeaderImg.vue?vue&type=template&id=f55681b0&scoped=true&"
import script from "./goodsHeaderImg.vue?vue&type=script&lang=ts&"
export * from "./goodsHeaderImg.vue?vue&type=script&lang=ts&"
import style0 from "./goodsHeaderImg.vue?vue&type=style&index=0&id=f55681b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55681b0",
  null
  
)

export default component.exports